import { OperatorNames } from '@msdk/definitions'

export type OptionEntry = { value: string; idml: string; description: string; fieldVisible?: boolean }

export const OPERATORS: Record<OperatorNames, OptionEntry> = {
  Between: { value: 'Between', idml: 'LBL_FILTER_OPERATOR_BETWEEN', description: 'between', fieldVisible: true },
  Contains: { value: 'Contains', idml: 'LBL_FILTER_OPERATOR_CONTAINS', description: 'contains', fieldVisible: true },
  Equals: { value: 'Equals', idml: 'LBL_FILTER_OPERATOR_EQUALS', description: 'equals', fieldVisible: true },
  Greater: { value: 'Greater', idml: 'LBL_FILTER_OPERATOR_GREATER', description: 'greater', fieldVisible: true },
  GreaterOrEqual: {
    value: 'GreaterOrEqual',
    idml: 'LBL_FILTER_OPERATOR_GREATER_EQUAL',
    description: 'greater or equal',
    fieldVisible: true,
  },
  In: { value: 'In', idml: 'LBL_FILTER_OPERATOR_IN', description: 'In', fieldVisible: true },
  IsBuAncestor: {
    value: 'IsBuAncestor',
    idml: 'LBL_FILTER_OPERATOR_BU_ANCESTOR',
    description: 'bu ancestor',
    fieldVisible: true,
  },
  IsBuDescendant: {
    value: 'IsBuDescendant',
    idml: 'LBL_FILTER_OPERATOR_BU_DESCENDANT',
    description: 'bu descendant',
    fieldVisible: true,
  },
  IsEmpty: { value: 'IsEmpty', idml: 'LBL_FILTER_OPERATOR_EMPTY', description: 'empty', fieldVisible: false },
  IsInLastMonth: {
    value: 'IsInLastMonth',
    idml: 'LBL_FILTER_OPERATOR_LAST_MONTH',
    description: 'in last month',
    fieldVisible: true,
  },
  IsNotNull: {
    value: 'IsNotNull',
    idml: 'LBL_FILTER_OPERATOR_NOT_NULL',
    description: 'not null',
    fieldVisible: false,
  },
  IsNullOrEmpty: {
    value: 'IsNullOrEmpty',
    idml: 'LBL_FILTER_OPERATOR_IS_EMPTY',
    description: 'is empty',
    fieldVisible: false,
  },
  IsNotNullOrEmpty: {
    value: 'IsNotNullOrEmpty',
    idml: 'LBL_FILTER_OPERATOR_IS_NOT_EMPTY',
    description: 'is not empty',
    fieldVisible: false,
  },
  Lower: { value: 'Lower', idml: 'LBL_FILTER_OPERATOR_LOWER', description: 'lower', fieldVisible: true },
  LowerOrEqual: {
    value: 'LowerOrEqual',
    idml: 'LBL_FILTER_OPERATOR_LOWER_EQUAL',
    description: 'lower or equal',
    fieldVisible: true,
  },
  NotEquals: {
    value: 'NotEquals',
    idml: 'LBL_FILTER_OPERATOR_NOT_EQUAL',
    description: 'not equals',
    fieldVisible: true,
  },
  IsNull: { value: 'IsNull', idml: 'LBL_FILTER_OPERATOR_NULL', description: 'is null', fieldVisible: false },
  StartsWith: {
    value: 'StartsWith',
    idml: 'LBL_FILTER_OPERATOR_STARTS_WITH',
    description: 'starts with',
    fieldVisible: true,
  },
  Before: { value: 'Lower', idml: 'LBL_FILTER_OPERATOR_BEFORE', description: 'is before', fieldVisible: true },
  OnOrBefore: {
    value: 'LowerOrEqual',
    idml: 'LBL_FILTER_OPERATOR_ON_OR_BEFORE',
    description: 'is on or before',
    fieldVisible: true,
  },
  IsNot: {
    value: 'NotEquals',
    idml: 'LBL_FILTER_OPERATOR_IS_NOT',
    description: 'is not',
    fieldVisible: true,
  },
  Is: { value: 'Equals', idml: 'LBL_FILTER_OPERATOR_IS', description: 'is', fieldVisible: true },
  After: { value: 'Greater', idml: 'LBL_FILTER_OPERATOR_AFTER', description: 'is after', fieldVisible: true },
  OnOrAfter: {
    value: 'GreaterOrEqual',
    idml: 'LBL_FILTER_OPERATOR_ON_OR_AFTER',
    description: 'is on or after',
    fieldVisible: true,
  },
}
